export enum FishClaims {
  species_detail = 'species_detail',
  waterbody_detail = 'waterbody_detail',
  fishing_area_detail = 'fishing_area_detail',
  access_points = 'access_points',
  available_regions = 'available_regions',
  waterbody_filters = 'waterbody_filters',
  fishing_reports = 'fishing_reports',
}

export enum FishGates {
  layer_upsell = 'layer_upsell',
  land_access = 'land_access',
  animated_wind = 'animated_wind',
  catch_data = 'catch_data',
}
